import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { SupplierNetworkApiResponse } from '../../shared/types';
import { SupplierNetwork } from '../../domain/entities';

export class SupplierNetworkApi {
    static async fetchByCNPJ(cnpj: string): Promise<SupplierNetwork> {
        const cleanCNPJ = cnpj.replace(/\D/g, '');
        const response = await apiClient.get<SupplierNetworkApiResponse>(
            API_ENDPOINTS.supplierNetwork(cleanCNPJ)
        );

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Failed to fetch supplier network');
        }

        return new SupplierNetwork(
            response.data.id,
            response.data.nome,
            cnpj,
            response.token
        );
    }
}

